import React from "react";
import "./hero.css";
import bannerImg from "../../assets/service/akashImg.webp";
import shape from "../../assets/service/shapeHrms.png";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import BookDemoModal from "../../landing-hrms/sections/DemoModal";
import { useState } from "react";
import { Helmet } from "react-helmet";
const Hero = () => {
    const [showContactModal, setShowContactModal] = useState(false);

    return (
        <>
            <Helmet>
                <title>HRMS Software for Payroll, Attendance & Employee Management</title>

                <meta
                    name="description"
                    content="Comprehensive HRMS software to manage payroll, attendance, leave, and employee records efficiently. Automate HR operations with a secure, cloud-based solution."
                />

                <meta
                    name="keywords"
                    content="HRMS software, payroll management system, attendance management software, employee management system, HR software India, HRMS ERP, HR automation software"
                />


                {/* Open Graph */}
                <meta property="og:title" content="HRMS Software for Payroll, Attendance & Employee Management" />
                <meta
                    property="og:description"
                    content="Automate payroll, attendance, and employee management with TechCognics cloud-based HRMS software."
                />
                <meta property="og:type" content="website" />
                <link
                    rel="preload"
                    as="image"
                    href={bannerImg}
                />
            </Helmet>
            <div id="home" className="banner__one ">
                <div className="banner-shape">
                    <div className="shape banner-shape-1"></div>
                    <div className="shape banner-shape-2"></div>
                    <div className="shape banner-shape-3"></div>
                    <div className="shape banner-shape-4"></div>
                    <img src={shape} className="shape banner-shape-5" alt="shape" />
                    <div className="shape banner-shape-6"></div>
                    <div className="shape banner-shape-7"></div>
                </div>

                <div className="container">
                    <div className="row align-items-center justify-content-center gy-4">
                        <div className="col-xl-6 col-lg-6 col-md-8">
                            <div className="banner__one-content text-lg-start">
                                <h2>
                                   HRMS Software for Payroll, Attendance & <span>Employee Management</span>
                                </h2>
                                <p>
                                    Streamline HR operations with a powerful HRMS. Automate payroll, attendance and employee management processes with ease.
                                </p>
                                <button onClick={() => setShowContactModal(true)} className="btn-two">
                                    Book Demo <span className="btn-icon"><ArrowForwardIcon fontSize="small" /></span>
                                </button>

                            </div>
                        </div>

                        <div className="col-xl-5 offset-xl-1 col-lg-6 col-md-9">
                            <div className="banner__one-image">
                                <div className="banner__one-image-wrapper">
                                    <div className="banner__one-image-wrapper-shapes animate-rotate">
                                        <div className="shape shape-1"></div>
                                        <div className="shape shape-2"></div>
                                    </div>
                                    {/* <img src={bannerImg} alt="banner image" /> */}
                                    <img
                                        src={bannerImg}
                                        alt="banner image"
                                        loading="eager"
                                        fetchpriority="high"

                                    />

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <BookDemoModal
                showDemo={showContactModal}
                handleDemoClose={() => setShowContactModal(false)}
            />

        </>




    );
};

export default Hero;
